import { RecordingDurationStore } from '@/utils/store/recordingDuration';
import { handleError } from '@/utils/helpers';
import axios from 'axios';

/**
 * 录音时长配置接口
 */
export interface RecordingDurationConfig {
  /** 当前已使用时长（秒） */
  currentUsage: number;
  /** 时长上限（秒） */
  maxLimit: number;
}

/**
 * 从远端获取录音时长配置并更新到 Store
 */
export async function fetchRecordingDurationConfigAndValue(userId: string): Promise<RecordingDurationConfig | null> {
  try {
    const response = await axios.get('/api/recording-duration/config', {
      params: { userId }
    });
    
    const config: RecordingDurationConfig = response.data.data;

    // 更新到 Store
    if (config) {
      RecordingDurationStore.updateCurrentDuration(config.currentUsage);
      RecordingDurationStore.setMaxDuration(config.maxLimit);
      console.log('录音时长配置获取并更新成功:', config);
    }

    return config;
  } catch (error) {
    handleError(error, '获取录音时长配置失败', 'recordingDuration');
    return null;
  }
}

/**
 * 上报当前录音时长使用情况
 */
export async function reportRecordingDuration(userId: string, duration: number): Promise<boolean> {
  try {
    const response = await axios.post('/api/recording-duration/report', null, {
      params: { 
        userId, 
        duration 
      }
    });
    
    console.log(`上报录音时长成功: userId=${userId}, duration=${duration}秒`);
    return response.data.data === 'success';
  } catch (error) {
    handleError(error, '上报录音时长失败', 'recordingDuration');
    return false;
  }
}
